import { useQuery } from '@tanstack/react-query';
import { regionsApi } from '../api/regions.api';
import type { RegionPaginationParams } from '../types/regions.types';
import { regionKeys } from './queryKeys';

export const useRegions = (pagination: RegionPaginationParams = {}) => {
  const {
    page = 1,
    pageSize = 10,
    searchTerm,
    isActive,
    countryIds,
    selector,
    parentId,
    getAllLevels,
  } = pagination;

  const { data, isLoading, isFetching } = useQuery({
    queryKey: regionKeys.list(
      page,
      pageSize,
      searchTerm,
      isActive,
      countryIds,
      selector,
      parentId,
      getAllLevels,
    ),
    queryFn: () =>
      regionsApi.getRegions({
        page,
        pageSize,
        searchTerm,
        isActive,
        countryIds,
        selector,
        parentId,
        getAllLevels,
      }),
    enabled: parentId ? !!parentId : true,
  });

  return {
    regions: data?.data?.items ?? [],
    pagination: {
      page: data?.data?.page ?? 1,
      pageSize: data?.data?.pageSize ?? 10,
      totalCount: data?.data?.totalCount ?? 0,
      totalPages: data?.data?.totalPages ?? 0,
      hasPreviousPage: data?.data?.hasPreviousPage ?? false,
      hasNextPage: data?.data?.hasNextPage ?? false,
    },
    isLoading,
    isFetching,
  };
};
